var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page flexcolumn" }, [
    _c("div", { staticClass: "jp-common-layout " }, [
      _c(
        "div",
        { staticClass: "jp-common-layout-center jp-flex-main" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "query-form",
              attrs: { size: "small", inline: true, model: _vm.searchForm },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.refreshList()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "storeyId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "楼层",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handSelect($event, "storeyId")
                        },
                      },
                      model: {
                        value: _vm.storeyValue,
                        callback: function ($$v) {
                          _vm.storeyValue = $$v
                        },
                        expression: "storeyValue",
                      },
                    },
                    _vm._l(
                      _vm.$dictUtils.getDictList("cec_storey"),
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.id },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "roomId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "空间",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handSelect($event, "roomId")
                        },
                      },
                      model: {
                        value: _vm.roomValue,
                        callback: function ($$v) {
                          _vm.roomValue = $$v
                        },
                        expression: "roomValue",
                      },
                    },
                    _vm._l(
                      _vm.$dictUtils.getDictList("cec_room"),
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.id },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "positionId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "位置",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handSelect($event, "positionId")
                        },
                      },
                      model: {
                        value: _vm.positionValue,
                        callback: function ($$v) {
                          _vm.positionValue = $$v
                        },
                        expression: "positionValue",
                      },
                    },
                    _vm._l(
                      _vm.$dictUtils.getDictList("cec_pos"),
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.id },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "proCode" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "项目编号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.proCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "proCode", $$v)
                      },
                      expression: "searchForm.proCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "项目名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "kindId1" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "工程类别",
                      },
                      on: { change: _vm.handCategories },
                      model: {
                        value: _vm.searchForm.kindId1,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "kindId1", $$v)
                        },
                        expression: "searchForm.kindId1",
                      },
                    },
                    _vm._l(_vm.kindCategoriesList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "kindId2" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "工程类型",
                      },
                      model: {
                        value: _vm.searchForm.kindId2,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "kindId2", $$v)
                        },
                        expression: "searchForm.kindId2",
                      },
                    },
                    _vm._l(_vm.kindTypeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refreshList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh-right" },
                      on: {
                        click: function ($event) {
                          return _vm.resetSearch()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bg-white top" },
            [
              _c("vxe-toolbar", {
                scopedSlots: _vm._u([
                  {
                    key: "buttons",
                    fn: function () {
                      return [
                        _c("GridSelect", {
                          ref: "gridselectRef",
                          attrs: {
                            title: "添加项目",
                            labelName: "name",
                            disabled: false,
                            showPagination: true,
                            dialogWidth: "80%",
                            showType: "none",
                            labelValue: "id",
                            value: _vm.spaceListIdsNew,
                            limit: 100,
                            columns: [
                              {
                                prop: "proCode",
                                label: "项目编号",
                              },
                              {
                                prop: "name",
                                label: "项目名称",
                              },
                              {
                                prop: "kindName1",
                                label: "工程类别",
                              },
                              {
                                prop: "kindName2",
                                label: "工程类型",
                              },
                              {
                                prop: "image",
                                width: "50",
                                label: "图片",
                              },
                            ],
                            searchs: [
                              {
                                prop: "proCode",
                                label: "项目编号",
                              },
                              {
                                prop: "name",
                                label: "项目名称",
                              },
                              {
                                option: _vm.kindCategoriesList,
                                prop: "kindId1",
                                label: "工程类别",
                              },
                              {
                                prop: "kindId2",
                                label: "工程类型",
                              },
                            ],
                            dataListUrl:
                              "/unmprojectpositionproject/cecUnmProjectPositionProject/list",
                            queryEntityUrl:
                              "/unmprojectpositionproject/cecUnmProjectPositionProject/queryById",
                            params: {
                              projectSetsId: _vm.setsDetForm.projectSetsId,
                              orders: [{ column: "a.create_date", asc: true }],
                              roomId: _vm.setsDetForm.setsPositionId,
                              storeyId: "",
                              positionId: "",
                            },
                          },
                          on: {
                            getValue: _vm.getValueGridProject,
                            clearParame: _vm.resetSearch,
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "div",
                { staticStyle: { height: "calc(100% - 80px)" } },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "cecUnmSetsProjectTable",
                      attrs: {
                        border: "full",
                        "auto-resize": "",
                        resizable: "",
                        height: "100%",
                        loading: _vm.loading,
                        size: "small",
                        "show-header-overflow": "",
                        "show-overflow": "",
                        "highlight-hover-row": "",
                        "menu-config": {},
                        "print-config": {},
                        "import-config": {
                          importMethod: _vm.importMethod,
                          types: ["csv", "xls", "xlsx"],
                          remote: true,
                        },
                        "export-config": {
                          remote: true,
                          filename:
                            "空间表数据" +
                            _vm.moment(new Date()).format("YYYY-MM-DD"),
                          sheetName: "空间表数据",
                          exportMethod: _vm.exportMethod,
                          types: ["xlsx"],
                          modes: ["current", "selected", "all"],
                        },
                        "sort-config": { remote: true },
                        data: _vm.dataList,
                        "checkbox-config": {},
                      },
                      on: { "sort-change": _vm.sortChangeHandle },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          width: "50",
                          fixed: "left",
                          align: "center",
                          title: "序号",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "proCode",
                          fixed: "left",
                          align: "center",
                          width: "100",
                          title: "项目编号",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.hasPermission(
                                  "cecunmsetmeal:cecUnmSetMeal:view"
                                )
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          underline: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.view(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.project.proCode)
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(scope.row.project.proCode)),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "isSelected",
                          width: "100",
                          align: "center",
                          title: "默认显示",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.id != "0"
                                  ? _c("el-switch", {
                                      attrs: {
                                        "active-color": "#13ce66",
                                        "inactive-color": "#ff4949",
                                        "active-value": "1",
                                        "inactive-value": "0",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.isSelectedChange(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.isSelected,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "isSelected", $$v)
                                        },
                                        expression: "scope.row.isSelected",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "name",
                          fixed: "left",
                          align: "center",
                          width: "150",
                          title: "项目名称",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.project.name)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "kindName1",
                          width: "150",
                          align: "center",
                          title: "工程类别",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.project.kindName1)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "kindName2",
                          width: "150",
                          align: "center",
                          title: "工程类型",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.project.kindName2)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "storeyId",
                          align: "center",
                          width: "100",
                          title: "楼层",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.storey
                                        ? scope.row.storey.nameCn
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "roomId",
                          align: "center",
                          width: "100",
                          title: "空间",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.room
                                        ? scope.row.room.nameCn
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "positionId",
                          align: "center",
                          width: "150",
                          title: "位置",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.position
                                        ? scope.row.position.nameCn
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "num",
                          align: "center",
                          width: "100",
                          title: "数量/面积",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "unitId",
                          align: "center",
                          width: "100",
                          title: "单位",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.project.unit
                                        ? scope.row.project.unit.unitEn
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "price",
                          align: "center",
                          width: "100",
                          title: "项目单价",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "flexBetween" }, [
                                  _c("span", [_vm._v("$")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$mathUtil.mathToFixed(
                                          scope.row.price
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "totalPrice",
                          align: "center",
                          width: "100",
                          title: "项目总价",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "flexBetween" }, [
                                  _c("span", [_vm._v("$")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$mathUtil.mathToFixed(
                                          scope.row.totalPrice
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "description",
                          align: "center",
                          "min-width": "100",
                          title: "备注",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    attrs: {
                      background: "",
                      size: "small",
                      "current-page": _vm.tablePage.currentPage,
                      "page-size": _vm.tablePage.pageSize,
                      total: _vm.tablePage.total,
                      "page-sizes": [
                        10,
                        20,
                        100,
                        1000,
                        { label: "全量数据", value: 1000000 },
                      ],
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.currentChangeHandle },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }